import { Route, Routes } from "react-router";
import { useFeatureFlagValue } from "../config/FeatureFlagManager/hooks.ts";
import { ConnectedTermsAndConditionsGuard } from "../feature-components/TermsAndConditions/ConnectedTermsAndConditionsGuard.tsx";
import { ClaLayout } from "../pages/CLA/ClaLayout.tsx";
import { ClaPage } from "../pages/CLA/ClaPage.tsx";
import { DeepResearchLayout, DeepResearchPage } from "../pages/DeepResearch";
import { InsightsAgentLayout } from "../pages/InsightsAgent/InsightsAgentLayout.tsx";
import { InsightsAgentPage } from "../pages/InsightsAgent/InsightsAgentPage.tsx";
import { LoginPage } from "../pages/login/LoginPage.tsx";
import { TermsAndConditionsPage } from "../pages/terms-and-conditions/TermsAndConditionsPage.tsx";
import { Redirect } from "./Redirect.tsx";
import { AuthenticationGuard } from "../feature-components/AuthenticationGuard/AuthenticatonGuard.tsx";

export const AppRoutes = () => {
  const enableClaMode = useFeatureFlagValue("enableClaMode");
  const enableChatFirstPage = useFeatureFlagValue("enableChatFirstPage");
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route
        path={"/terms-and-conditions"}
        Component={TermsAndConditionsPage}
      />
      {enableClaMode ? (
        // If CLA mode is enabled, use the CLA layout and routes
        <>
          <Route
            path="chats"
            element={
              <AuthenticationGuard>
                <ConnectedTermsAndConditionsGuard>
                  <ClaLayout />
                </ConnectedTermsAndConditionsGuard>
              </AuthenticationGuard>
            }
          >
            <Route path=":id" element={<ClaPage />} />
          </Route>
          <Route path="*" element={<Redirect path={"/chats/new"} />} />
        </>
      ) : enableChatFirstPage ? (
        <>
          <Route
            path="deep-research"
            element={
              <AuthenticationGuard>
                <ConnectedTermsAndConditionsGuard>
                  <DeepResearchLayout />
                </ConnectedTermsAndConditionsGuard>
              </AuthenticationGuard>
            }
          >
            <Route path=":id" element={<DeepResearchPage />} />
          </Route>
          <Route path="*" element={<Redirect path={"/deep-research/new"} />} />
        </>
      ) : (
        <>
          <Route
            path="workflows"
            element={
              <AuthenticationGuard>
                <ConnectedTermsAndConditionsGuard>
                  <InsightsAgentLayout />
                </ConnectedTermsAndConditionsGuard>
              </AuthenticationGuard>
            }
          >
            <Route path=":id" element={<InsightsAgentPage />} />
          </Route>
          <Route path="*" element={<Redirect path={"/workflows/new"} />} />
        </>
      )}
    </Routes>
  );
};
